<template>
  <div class="global-search-container" v-if="isShowSearch">
    <div class="input-shadow" @click="handleClose"></div>
    <div class="search-container">
      <div class="input-container">
        <el-input placeholder="请输入手机号码或者联系人姓名" class="search-input" maxlength="20" ref="searchRef" v-model="keyword" @keyup.enter.native="handleSearchNormal" clearable  />
        <i class="iconfont iconsousuo search-icon" @click="handleSearchNormal"></i>
      </div>
      <div class="global-search-con search-for-more">
        <h1 class="title">客户基本信息</h1>
        <div class="filter-item" id="sign_up_house_names">
          <span class="label">进线楼盘:</span>
          <div>
            <el-input placeholder="请输入" size="small"  v-model="condition.sign_up_house_names" maxlength="30" clearable ></el-input>
          </div>
        </div>
        <div class="filter-item" id="level">
          <span class="label">当前客户等级:</span>
          <div class="filter-flex filter-fu">
            <span class="filter-panel" :class="condition.level == key && 'active'" v-for="(value, key) in options.customer_levels" :key="key" @click="handleSelect('level', key)">{{value}}</span>
          </div>
        </div>
        <div class="filter-item" id="history_level">
          <span class="label">客户历史等级:</span>
          <div class="filter-flex filter-fu">
            <span class="filter-panel" :class="condition.history_level == key && 'active'" v-for="(value, key) in options.customer_levels_for_create" :key="key" @click="handleSelect('history_level', key)">{{value}}</span>
          </div>
        </div>
        <div class="wrapper clearfix">
          <div class="filter-item platform">
            <span class="label">客户来源:</span>
            <el-radio-group v-model="condition.platform_source_type" size="small" id="platform">
              <el-radio-button v-for="(platform, key) in platformlist" :key="key" :label="platform.id">{{platform.show_name}}</el-radio-button>
            </el-radio-group>
          </div>
          <div class="blcok clearfix" v-if="condition.platform_source_type == '-3'">
            <div class="b-con-form">
              <label class="c-label sp">来源渠道：</label>
              <el-select class="c-input-area" id="channel" popper-class="condition-popover-style" v-model="condition.channel" placeholder="请选择" @change="handleChangeChannel" clearable>
                <el-option label="全部" value=""></el-option>
                <el-option v-for="(channel, key) in options.customer_offline_channels" :key="key" :label="channel" :value="key"></el-option>
              </el-select>
            </div>
            <div class="b-con-form" v-if="condition.channel == 2">
              <el-input placeholder="请输入转介人信息" size="small" id="sub_channel_text" v-model="condition.sub_channel_text" maxlength="20" clearable ></el-input>
            </div>
            <div class="b-con-form" v-if="condition.channel == 7 || condition.channel == 11 || condition.channel == 12" style="width: 120px;min-width: 120px;">
              <el-select class="c-input-area" id="sub_channel_id" popper-class="condition-popover-style" v-model="condition.sub_channel_id" placeholder="请选择"  clearable>
                <el-option v-for="(channel, key) in getChannels" :key="key" :label="channel" :value="key"></el-option>
              </el-select>
            </div>
          </div>
          <div class="blcok" v-if="condition.platform_source_type > 0">
            <div class="b-con-form" >
              <label class="c-label sp">来源渠道：</label>
              <el-select class="c-input-area" id="channel" popper-class="condition-popover-style" v-model="condition.channel" placeholder="请选择" clearable>
                <el-option label="全部" value=""></el-option>
                <el-option v-for="(channel, key) in options.customer_online_channels_2" :key="key" :label="channel" :value="key"></el-option>
              </el-select>
            </div>
            <div class="b-con-form" >
              <label class="c-label">来源方式：</label>
              <el-select class="c-input-area" id="source" popper-class="condition-popover-style" v-model="condition.source" placeholder="请选择" clearable>
                <el-option label="全部" value=""></el-option>
                <el-option v-for="(channel, key) in options.customer_online_sources" :key="key" :label="channel" :value="key"></el-option>
              </el-select>
            </div>
            <div class="b-con-form" >
              <label class="c-label">来源终端：</label>
              <el-select class="c-input-area" id="terminal" popper-class="condition-popover-style" v-model="condition.terminal" placeholder="请选择" clearable>
                <el-option label="全部" value=""></el-option>
                <el-option v-for="(channel, key) in options.customer_online_terminals" :key="key" :label="channel" :value="key"></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="filter-item" id="thread_times_option">
          <span class="label">进线次数:</span>
          <div class="filter-flex filter-fu">
            <span class="filter-panel" :class="condition.thread_times_option == 1 && 'active'" @click="handleSelect('thread_times_option', 1)">1</span>
            <span class="filter-panel" :class="condition.thread_times_option == 2 && 'active'" @click="handleSelect('thread_times_option', 2)">1 次以上</span>
          </div>
        </div>
        <div class="filter-item" id="time_option">
          <span class="label">时间:</span>
          <div class="filter-flex">
            <el-radio-group v-model="condition.time_option" @change="handleTimeOptChange" class="radio-group">
              <el-radio :label="1">创客时间</el-radio>
              <el-radio :label="2">进线时间</el-radio>
              <el-radio :label="3">最后一次进线时间</el-radio>
              <el-radio :label="4">最近分配时间</el-radio>
              <el-radio :label="5">最后跟进时间</el-radio>
              <el-radio :label="6">下次跟进时间</el-radio>
            </el-radio-group>
            <el-date-picker v-model="timeRange" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small" class="time-range" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" :disabled="!condition.time_option" @change="handleTimeChange" clearable ></el-date-picker>
          </div>
        </div>
        <div class="filter-item" id="belong_option">
          <span class="label">归属人:</span>
          <div class="filter-flex">
            <el-radio-group v-model="condition.belong_option" class="radio-group">
              <el-radio :label="1">首次归属人</el-radio>
              <el-radio :label="2">上一个归属人</el-radio>
              <el-radio :label="3">当前归属人</el-radio>
              <el-radio :label="4">归属过的员工(在职)</el-radio>
              <el-radio :label="5">归属过的员工(离职)</el-radio>
            </el-radio-group>
            <template v-if="condition.belong_option != 5">
              <agent-selector class="b-con-filter-area" style="margin-top: 20px;" v-model="belong" ref="customeBelongRef" :agentType="1" :onlyShowActive="true" :disabled="!condition.belong_option" size="small"></agent-selector>
            </template>
            <template v-else-if="condition.belong_option == 5">
              <el-select v-model="condition.belong_offline" placeholder="请选择" class="condition-select" style="margin-top: 20px;" size="small" clearable >
                <el-option :label="item.name" :value="item.id" v-for="item in offlinelist" :key="item.id"></el-option>
              </el-select>
            </template>
            
          </div>
        </div>
        <div class="filter-item">
          <span class="label">写跟进内容:</span>
          <div>
            <el-input placeholder="请输入" size="small" id="follow_keywords" v-model="condition.follow_keywords" clearable ></el-input>
          </div>
        </div>
        <div class="filter-item">
          <span class="label">客户备注:</span>
          <div>
            <el-input placeholder="请输入" size="small" id="remark_keywords" v-model="condition.remark_keywords" clearable ></el-input>
          </div>
        </div>
        <div class="filter-item">
          <span class="label"></span>
          <div class="filter-flex">
            <el-select id="qualifications" v-model="condition.qualifications" placeholder="是否有购房资质" size="small" class="condition-select" clearable >
              <el-option :label="value" :value="key" v-for="(value, key) in options.customer_qualifications" :key="key"></el-option>
            </el-select>
            <el-select id="house_type" v-model="condition.house_type" placeholder="请选择物业类型" size="small" class="condition-select" clearable >
              <el-option :label="value" :value="key" v-for="(value, key) in options.house_types" :key="key"></el-option>
            </el-select>
            <el-select id="voucher_status" v-model="condition.voucher_status" placeholder="请选择客户状态" size="small" class="condition-select" clearable >
              <el-option label="有报备的" :value="1"></el-option>
              <el-option label="有带看的" :value="2"></el-option>
              <el-option label="有成交的" :value="3"></el-option>
            </el-select>
            <el-select id="next_follow_option" v-model="condition.next_follow_option" placeholder="是否设置了下次跟进时间" size="small" class="condition-select" clearable >
              <el-option label="是" :value="1"></el-option>
              <el-option label="无" :value="2"></el-option>
            </el-select>
          </div>
        </div>
        <div class="btn-con">
          <el-button class="global-btn primary-round" size="mini" @click="handleCancel">清空选项</el-button>
          <el-button class="global-btn primary-round" size="mini" @click="handleClose">取消</el-button>
          <el-button class="global-btn primary" size="mini" @click="handleSearch">选择</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AgentSelector from '@/components/select/AgentSelector';
import {getPlatformSelect} from '@/api/custome';
import {getOfflineList} from '@/api/base';

export default{
  name: 'GlobalSearch',
  components: {
    AgentSelector
  },
  data () {
    return {
      isShowSearch: false,
      options: {},
      condition: {
        level: '',
        history_level: '',
        source: '',
        channel: '',
        thread_times_option: '',
        platform_source_type:'',
      },
      platformlist:[],
      offlinelist: [],
      keyword: '',
      timeRange: [],
      belong: {}
    }
  },
  computed: {
    getChannels () {
      const chan = this.condition.channel;
      if (chan == 7) return this.options.sub_channel_7;
      else if (chan == 11) return this.options.sub_channel_11;
      else if (chan == 12) return this.options.sub_channel_12;
      else return [];
    }
  },
  methods: {
    async initial (status) {
      this.isShowSearch = true;
      this.options = await this.$store.dispatch('initConfig', ['customer_levels', 'customer_levels_for_create', 'customer_online_terminals', 'customer_online_sources', 'customer_online_channels_2','customer_offline_channels', 'customer_qualifications', 'house_types', 'sub_channel_7', 'sub_channel_11', 'sub_channel_12']);
      this.initPlatform();
      this.initOfflineList();
      this.$nextTick(_ => {
        // input搜索框获取光标
        if (this.$refs.searchRef) {
          this.$refs.searchRef.focus();
        }
        if (status == 1) {
          this.handleLoadData();
        }
      })
    },
    // 普通搜索跳转（只搜索文本框内容）
    handleSearchNormal () {
      if (!this.keyword) {
        this.$message.error('请输入搜索内容');
        return null;
      }
      // let filterText = '';
      // if (/^\d{4,12}$/.test(this.keyword)) {
      //   filterText = `contact_tel=${this.keyword}`;
      // } else {
      //   filterText = `name=${this.keyword}`;
      // }
      // // 添加随机值变化(用来确保每次都能刷新页面)
      // const a = this.condition.a ? Number(this.condition.a) + 1 : 1;
      // // 判断当前页面是否已经是搜索结果页
      // const url = `/workspace/search/quickly-result?` + filterText + '&a=' + a;
      // if (this.$route.name == 'QuicklyResult') {
      //   this.$router.replace(url);
      // } else {
      //   this.$router.push(url);
      // }
      let data = {};
      if (/^\d{4,12}$/.test(this.keyword)) {
        data.contact_tel = this.keyword;
      } else {
        data.name= this.keyword;
      }
      // 添加随机值变化(用来确保每次都能刷新页面)
      data.a = this.condition.a ? Number(this.condition.a) + 1 : 1;
      const searchKey = this.groupCondition(data)

      // 判断当前页面是否已经是搜索结果页
      const url = `/workspace/search/quickly-result`;
      if (this.$route.name == 'QuicklyResult') {
        this.$router.push({path:url,query:{data,searchKey}});
      } else {
        this.$router.push({path:url,query:{data,searchKey}});
      }
      this.handleClose();
    },
    // 快捷搜索（包含文本框内容以及快捷框内容）
    handleSearch () {
      // 选了日期选项且未选择具体时间
      if (this.condition.time_option && !this.condition.start_date) {
        this.$message.error('请先选择具体日期范围');
        return null;
      }
      const data = {...this.condition};
      if (this.belong && data.belong_option != 5) {
        data.belong_id = this.belong.admin_id || '';
        data.belong_dept   = this.belong.dept_id || '';
      } else if (data.belong_option == 5) {
        data.belong_id = data.belong_offline || '';
      }
      delete data.belong_offline;
      // 选了归属人类型且未选择具体归属人
      if (data.belong_option && !data.belong_id && !data.belong_dept) {
        this.$message.error('请先选择具体归属人');
        return null;
      }
      // 解析文本框内容
      if (this.keyword) {
        if (/^\d{4,12}$/.test(this.keyword)) data.contact_tel = this.keyword;
        else data.name = this.keyword;
      } else {
        data.contact_tel = '';
        data.name = '';
      }
      // 添加随机值变化(用来确保每次都能刷新页面)
      data.a = data.a ? Number(data.a) + 1 : 1;
      // 过滤空值
      const list = [];
      Object.keys(data).map(v => {
        if (data[v] != '') {
          list.push(`${v}=${data[v]}`);
        }
      })
      const searchKey = this.groupCondition(data)
      // 判断当前页面是否已经是搜索结果页
      const url = `/workspace/search/quickly-result`
      if (this.$route.name == 'QuicklyResult') {
        this.$router.replace({path:url,query:{data,searchKey}});
      } else {
        this.$router.push({path:url,query:{data,searchKey}});
      }
      this.handleClose();
    },
    handleChangeChannel () {
      this.$set(this.condition, 'sub_channel_id', '');
      this.$set(this.condition, 'sub_channel_text', '');
    },
    groupCondition(data){
      let checkedArr = [];
      let checkedObj={}
      if(data.name){
        checkedObj={
          id:'name',
          name: '客户姓名：'+data.name,
          val:data.name
        }
        checkedArr.push(checkedObj)
      }
      if(data.contact_tel){
        checkedObj={
          id:'contact_tel',
          name: (data.contact_tel.length > 4 ? '手机全号：' : '手机尾号') +data.contact_tel,
          val:data.contact_tel
        }
        checkedArr.push(checkedObj)
      }
      if(data.sign_up_house_names){
        checkedObj={
          id:'sign_up_house_names',
          name: data.sign_up_house_names,
          val:data.sign_up_house_names
        }
        checkedArr.push(checkedObj)
      }
      if(data.level){
        checkedObj={
          id:'level',
          name: $("#level .active").text()+'等级',
          val:data.level
        }
        checkedArr.push(checkedObj)
      }
      if(data.history_level){
        checkedObj={
          id:'history_level',
          name: $("#history_level .active").text()+'历史等级',
          val:data.history_level
        }
        checkedArr.push(checkedObj)
      }
      if(data.platform_source_type){
        checkedObj={
          id:'platform_source_type',
          name:'客户来源：'+$("#platform .is-active .el-radio-button__inner").text(),
          val:data.level
        }
        checkedArr.push(checkedObj)
      }
      if(data.source){
        checkedObj={
          id:'source',
          name: $("#source").val(),
          val:data.source
        }
        checkedArr.push(checkedObj)
      }
      if(data.channel){
        checkedObj={
          id:'channel',
          name: $("#channel").val(),
          val:data.channel
        }
        checkedArr.push(checkedObj)
      }
      if(data.sub_channel_text){
        checkedObj={
          id:'sub_channel_text',
          name: '转介人信息：' + $("#sub_channel_text").val(),
          val: data.sub_channel_text
        }
        checkedArr.push(checkedObj)
      }
      if(data.sub_channel_id){
        checkedObj={
          id:'sub_channel_id',
          name: $("#sub_channel_id").val(),
          val: data.sub_channel_id
        }
        checkedArr.push(checkedObj)
      }
      if(data.terminal){
        checkedObj={
          id:'terminal',
          name: $("#terminal").val(),
          val:data.terminal
        }
        checkedArr.push(checkedObj)
      }
      if(data.time_option){
        checkedObj={
          id:'time_option',
          name:$("#time_option .is-checked .el-radio__label").text()+':'+data.start_date+'至'+data.end_date,
          val:data.time_option
        }
        checkedArr.push(checkedObj)
      }
      if(data.thread_times_option){
        checkedObj={
          id:'thread_times_option',
          name: data.thread_times_option == 1 ? '进线 1 次' : '进线 1 次以上',
          val:data.thread_times_option
        }
        checkedArr.push(checkedObj)
      }
      if(data.belong_option){
        checkedObj={
          id:'belong_option',
          name:$("#belong_option .is-checked .el-radio__label").text()+':'+ $("#belong_option .el-input .el-input__inner").val(),
          val:data.belong_option
        }
        checkedArr.push(checkedObj)
      }
      if(data.qualifications){
        checkedObj={
          id:'qualifications',
          name:$("#qualifications").val()+'购房资质',
          val:data.qualifications
        }
        checkedArr.push(checkedObj)
      }
      if(data.house_type){
        checkedObj={
          id:'house_type',
          name:$("#house_type").val(),
          val:data.house_type
        }
        checkedArr.push(checkedObj)
      }
      if(data.voucher_status){
        checkedObj={
          id:'voucher_status',
          name:$("#voucher_status").val()+'客户',
          val:data.voucher_status
        }
        checkedArr.push(checkedObj)
      }
      if(data.next_follow_option){
        checkedObj={
          id:'next_follow_option',
          name:$("#next_follow_option").val()+'下次跟进时间的客户',
          val:data.next_follow_option
        }
        checkedArr.push(checkedObj)
      }
      if (data.follow_keywords) {
        checkedObj={
          id:'follow_keywords',
          name: '写跟进内容：' + $("#follow_keywords").val(),
          val:data.follow_keywords
        }
        checkedArr.push(checkedObj)
      }
      if (data.remark_keywords) {
        checkedObj={
          id:'remark_keywords',
          name: '客户备注：' + $("#remark_keywords").val(),
          val:data.remark_keywords
        }
        checkedArr.push(checkedObj)
      }
      console.log(checkedArr)
      return checkedArr;
    },
    // 清空所有选项
    handleCancel () {
      this.condition = {
        level: '',
        source: '',
        channel: '',
        thread_times_option: '',
        platform_source_type:'',
        history_level: ''
      };
      this.keyword = '';
      this.timeRange = [];
      this.belong = {};
    },
    // 关闭弹窗
    handleClose () {
      this.isShowSearch = false;
      this.handleCancel();
    },
    handleTimeChange (date) {
      this.condition.start_date = !date ? '' : date[0];
      this.condition.end_date = !date ? '' : date[1];
    },
    handleTimeOptChange () {
      this.handleTimeChange(null);
      this.timeRange = [];
    },
    // 初始化的时候加载已有数据
    handleLoadData () {
      const query = this.$route.query.data;
      this.condition = {
        ...this.condition,
        ...query
      }
      // 需要转成Number类型的参数
      if (this.condition.time_option) this.condition.time_option = Number(this.condition.time_option);
      if (this.condition.belong_option) this.condition.belong_option = Number(this.condition.belong_option);
      if (this.condition.voucher_status) this.condition.voucher_status = Number(this.condition.voucher_status);
      if (this.condition.next_follow_option) this.condition.next_follow_option = Number(this.condition.next_follow_option);
      // 解析文本框内容
      if (query && (query.name || query.contact_tel)) {
        this.keyword = query.name || query.contact_tel;
      }
      // 解析日期
      if (this.condition.start_date && this.condition.end_date) {
        this.timeRange = [this.condition.start_date, this.condition.end_date];
      }
      // 解析归属人
      if (this.condition.belong_option != 5) {
        if (this.condition.belong_id) {
          this.belong = {admin_id: this.condition.belong_id};
        }else if (this.condition.belong_dept) {
          this.belong = {dept_id: this.condition.belong_dept};
        }
      } else {
        this.condition.belong_offline = this.condition.belong_id;
      }
      
    },
    handleSelect (name, value) {
      if (this.condition[name] == value) {
        this.condition[name] = '';
      } else {
        this.condition[name] = value;
      }
    },
    async initPlatform () {
      try {
        const res = await getPlatformSelect();
        this.platformlist = res;
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      }
    },
    async initOfflineList () {
      try {
        const res = await getOfflineList();
        this.offlinelist = res;
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      }
    }
  },
}
</script>
<style lang="less">
@import url('~@/assets/style/workspace/globalSearch.less');
  // 表格样式
  .search-for-more{
    .wrapper{
      .platform{
        display: flex;
        margin-top:30px;
        .title{
          margin-right: 20px;
          margin-top:8px;
        }
        .el-radio-button__orig-radio:checked+.el-radio-button__inner{
          color: #FFF;
          background-color: #409EFF;
          -webkit-box-shadow: -1px 0 0 0 #409EFF;
          box-shadow: -1px 0 0 0 #409EFF;
        }
        .el-radio-button__inner{
          border:none;
          background-color: #f5f5f5;
          margin-right:10px;
          border-radius: 0;
        }
      }
    }
    .b-con-form{
      width: 28%;
      margin-right: 2%;
      margin-top: 15px;
      float: left;
      min-width: 240px;
      .box();
      &:nth-of-type(3n) {
        margin-right: 0;
      }
    }
    .mr0{
      margin-right: 0!important;
    }
    .c-label{
      font-size: 12px;
      color: #999;
      line-height: 30px;
      display: block;
      width: 80px;
      text-align: right;
      height: 30px;
      margin-right: 8px;
      &:after{
        content: '';
        display: inline-block;
        width: 100%;
      }
      &.sp{
        width: 114px;
      }
    }
    .c-input-area{
      display: block;
      height: 30px;
      line-height: 30px;
      font-size: 12px;
      color: #333;
      .boxFlexAll();
      .el-input__inner,.el-input__suffix *{
        height: 30px;
        line-height: 30px;
        font-size: 12px;
        color: #333;
      }
      .el-range__icon{
        line-height: 24px;
      }
      .el-range-separator{
        line-height: 24px;
        font-size: 12px;
        width: 20px;
      }
      .el-range-input{
        font-size: 12px;
        color: #333;
      }
    }


  }
</style>